/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    government_programs_facility_participates_in: valueSchema,
  },
}
